import { render, staticRenderFns } from "./DecisionStudies.vue?vue&type=template&id=1c0db433&"
import script from "./DecisionStudies.vue?vue&type=script&lang=js&"
export * from "./DecisionStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports